import { z } from 'zod';
import { PlayerProfile } from './profile';

// the browser exchanges a Firebase ID token for an HttpOnly session cookie
export const SessionRequest = z.object({
  idToken: z.string().min(20),
  audience: z.enum(['player', 'admin']).default('player'),
});
export type SessionRequest = z.infer<typeof SessionRequest>;

export const UserSummary = z.object({
  id: z.string().uuid(),
  email: z.string().email().nullable(),
  displayName: z.string().nullable(),
  emailVerified: z.boolean(),
  createdAt: z.string(),
});
export type UserSummary = z.infer<typeof UserSummary>;

export const SessionReply = z.object({ user: UserSummary, csrfToken: z.string(), expiresAt: z.string() });
export type SessionReply = z.infer<typeof SessionReply>;

export const MeReply = z.object({
  user: UserSummary,
  profile: PlayerProfile,
  isAdmin: z.boolean(),
  csrfToken: z.string(),
});
export type MeReply = z.infer<typeof MeReply>;
